import React from 'react';
import WorkspaceLinkCard from './WorkspaceLinkCard';

/**
 * One-shot "Workspace ready ✅" modal shown right after a new organisation
 * is registered. Surfaces the per-org login URL prominently with copy + QR
 * before the new owner is dropped into their dashboard.
 *
 * Props:
 *   slug:       organisation slug (required)
 *   orgName:    human-readable name (used in copy)
 *   onContinue: called when the user dismisses the modal (continue to dashboard)
 */
export function WorkspaceReadyModal({ slug, orgName = 'your workspace', onContinue }) {
  if (!slug) return null;

  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="workspace-ready-title"
      data-testid="workspace-ready-modal"
      style={{ zIndex: 250 }}
    >
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '640px', width: '100%' }}
      >
        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '0.25rem' }}>🎉</div>
          <h2 id="workspace-ready-title" style={{ margin: 0 }}>Workspace ready!</h2>
          <p style={{ margin: '0.5rem 0 0', color: 'hsl(var(--muted-foreground))' }}>
            <strong>{orgName}</strong> is now live on Kids WiseApp. Share the link below with your
            staff and parents so they can sign in to your branded portal.
          </p>
        </div>

        <WorkspaceLinkCard slug={slug} orgName={orgName} compact={false} />

        <div
          style={{
            background: 'hsl(var(--muted) / 0.5)',
            borderRadius: 'var(--radius)',
            padding: '0.75rem 1rem',
            fontSize: '0.85rem',
            color: 'hsl(var(--muted-foreground))',
            marginBottom: '1rem',
          }}
        >
          <strong>Tip:</strong> You can always find this link again in
          {' '}<em>Admin → Organization → Your workspace login link</em>.
        </div>

        <div className="modal-actions" style={{ justifyContent: 'flex-end' }}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onContinue}
            data-testid="workspace-ready-continue"
          >
            Continue to dashboard →
          </button>
        </div>
      </div>
    </div>
  );
}

export default WorkspaceReadyModal;
